// import React, { useState, useEffect, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import {
//   FaArrowLeft,
//   FaArrowRight,
//   FaCheckCircle,
//   FaClock,
//   FaYoutube,
//   FaBookOpen,
//   FaStar,
//   FaSpinner,
//   FaSave,
//   FaExternalLinkAlt,
//   FaList,
//   FaCheck,
// } from "react-icons/fa";
// import axios from "../utils/axiosConfig";
// import toast from "react-hot-toast";
// import Loader from "../components/common/Loader";
// import { useFooter } from "../context/FooterContext";

// const TopicDetail = () => {
//   const { topicId } = useParams();
//   const navigate = useNavigate();
//   const { setShowFooter } = useFooter();
//   const [topic, setTopic] = useState(null);
//   const [nextTopic, setNextTopic] = useState(null);
//   const [previousTopic, setPreviousTopic] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [markingComplete, setMarkingComplete] = useState(false);
//   const [notes, setNotes] = useState("");
//   const [timeSpent, setTimeSpent] = useState(0);
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [showNotes, setShowNotes] = useState(false);
//   const timerRef = useRef(null);
//   const [videoStarted, setVideoStarted] = useState(false);

//   useEffect(() => {
//     setShowFooter(false);
//     fetchTopic();
//     checkDarkMode();
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => {
//       setShowFooter(true);
//       if (timerRef.current) clearInterval(timerRef.current);
//       window.removeEventListener("resize", checkMobile);
//     };
//   }, [topicId]);

//   const checkMobile = () => {
//     setIsMobile(window.innerWidth <= 768);
//   };

//   const checkDarkMode = () => {
//     const dark = document.documentElement.getAttribute("data-theme") === "dark";
//     setIsDarkMode(dark);
//     const observer = new MutationObserver(() => {
//       const dark =
//         document.documentElement.getAttribute("data-theme") === "dark";
//       setIsDarkMode(dark);
//     });
//     observer.observe(document.documentElement, {
//       attributes: true,
//       attributeFilter: ["data-theme"],
//     });
//     return () => observer.disconnect();
//   };

//   const fetchTopic = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`/api/roadmap/topics/${topicId}`);
//       setTopic(response.data.topic);
//       setNextTopic(response.data.nextTopic);
//       setPreviousTopic(response.data.previousTopic);
//       setNotes(response.data.topic.progress?.notes || "");
//       setTimeSpent(response.data.topic.progress?.timeSpent || 0);
//     } catch (error) {
//       if (error.response?.status === 403) {
//         toast.error("Complete previous topics first");
//         navigate(-1);
//       } else {
//         toast.error("Failed to fetch topic");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const startTimer = () => {
//     if (!timerRef.current && !videoStarted) {
//       setVideoStarted(true);
//       timerRef.current = setInterval(() => {
//         setTimeSpent((prev) => prev + 1);
//       }, 1000);
//     }
//   };

//   const stopTimer = () => {
//     if (timerRef.current) {
//       clearInterval(timerRef.current);
//       timerRef.current = null;
//     }
//   };

//   const updateProgress = async () => {
//     try {
//       await axios.put(`/api/roadmap/topics/${topicId}/progress`, {
//         timeSpent: (topic?.progress?.timeSpent || 0) + timeSpent,
//         notes,
//       });
//     } catch (error) {
//       console.error("Failed to update progress:", error);
//     }
//   };

//   const handleMarkComplete = async () => {
//     setMarkingComplete(true);
//     stopTimer();
//     try {
//       await axios.post(`/api/roadmap/topics/${topicId}/complete`, {
//         timeSpent: (topic?.progress?.timeSpent || 0) + timeSpent,
//         notes,
//       });
//       toast.success("Topic completed!");

//       if (nextTopic?.isUnlocked) {
//         navigate(`/learning/topic/${nextTopic._id}`);
//       } else {
//         navigate(`/learning/course/${topic?.domainId?._id}`);
//       }
//     } catch (error) {
//       toast.error("Failed to mark topic as completed");
//     } finally {
//       setMarkingComplete(false);
//     }
//   };

//   const extractYouTubeId = (url) => {
//     const regExp =
//       /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//     const match = url.match(regExp);
//     return match && match[2].length === 11 ? match[2] : null;
//   };

//   const getYouTubeEmbedUrl = (url) => {
//     const videoId = extractYouTubeId(url);
//     if (videoId) {
//       return `https://www.youtube.com/embed/${videoId}`;
//     }
//     return url;
//   };

//   const getTextColor = () => (isDarkMode ? "#f1f5f9" : "#1e293b");
//   const getTextSecondary = () => (isDarkMode ? "#94a3b8" : "#64748b");
//   const getBorderColor = () =>
//     isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
//   const getCardBackground = () =>
//     isDarkMode ? "rgba(30, 30, 45, 0.8)" : "rgba(255, 255, 255, 0.9)";

//   if (loading) return <Loader />;
//   if (!topic) return <div>Topic not found</div>;

//   const isCompleted = topic.progress?.status === "completed";
//   const isInProgress = topic.progress?.status === "in_progress";
//   const youtubeEmbedUrl = getYouTubeEmbedUrl(topic.primaryVideo);

//   return (
//     <div
//       style={{
//         maxWidth: "1400px",
//         margin: "0 auto",
//         padding: isMobile ? "1rem" : "2rem",
//         background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
//         minHeight: "100vh",
//       }}
//     >
//       {/* Navigation Bar */}
//       <div
//         style={{
//           marginBottom: "1.5rem",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap",
//           gap: "1rem",
//         }}
//       >
//         <button
//           onClick={() => navigate(-1)}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "0.5rem",
//             background: "none",
//             border: "none",
//             color: "#8b5cf6",
//             cursor: "pointer",
//             fontSize: "0.9rem",
//           }}
//         >
//           <FaArrowLeft /> Back to Course
//         </button>

//         <div style={{ display: "flex", gap: "0.5rem" }}>
//           <span
//             style={{
//               fontSize: "0.8rem",
//               color: getTextSecondary(),
//               background: getCardBackground(),
//               padding: "0.3rem 0.8rem",
//               borderRadius: "20px",
//             }}
//           >
//             {topic.domainId?.name}
//           </span>
//         </div>
//       </div>

//       {/* Main Content - Responsive Grid */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: isMobile ? "1fr" : "1fr 0.8fr",
//           gap: "1.5rem",
//         }}
//       >
//         {/* Left Column - Video Player */}
//         <div>
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             style={{
//               background: "#000000",
//               borderRadius: "20px",
//               overflow: "hidden",
//               boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
//               position: "relative",
//             }}
//           >
//             <div style={{ position: "relative", paddingBottom: "56.25%" }}>
//               <iframe
//                 src={youtubeEmbedUrl}
//                 title={topic.title}
//                 frameBorder="0"
//                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                 allowFullScreen
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   width: "100%",
//                   height: "100%",
//                 }}
//                 onLoad={startTimer}
//               />
//             </div>
//           </motion.div>

//           {/* Video Info */}
//           <div style={{ marginTop: "1rem", padding: "0 0.5rem" }}>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "0.5rem",
//                 flexWrap: "wrap",
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: "0.7rem",
//                   color: getTextSecondary(),
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "0.2rem",
//                 }}
//               >
//                 <FaClock size={10} /> {topic.estimatedTime} minutes
//               </span>
//               {topic.difficulty && (
//                 <span
//                   style={{
//                     fontSize: "0.65rem",
//                     padding: "0.15rem 0.5rem",
//                     borderRadius: "4px",
//                     background:
//                       topic.difficulty === "beginner"
//                         ? "#10b98120"
//                         : topic.difficulty === "intermediate"
//                           ? "#f59e0b20"
//                           : "#ef444420",
//                     color:
//                       topic.difficulty === "beginner"
//                         ? "#10b981"
//                         : topic.difficulty === "intermediate"
//                           ? "#f59e0b"
//                           : "#ef4444",
//                   }}
//                 >
//                   {topic.difficulty}
//                 </span>
//               )}
//               {isInProgress && !isCompleted && (
//                 <span
//                   style={{
//                     fontSize: "0.65rem",
//                     color: "#8b5cf6",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "0.2rem",
//                   }}
//                 >
//                   In Progress
//                 </span>
//               )}
//               {isCompleted && (
//                 <span
//                   style={{
//                     fontSize: "0.65rem",
//                     color: "#10b981",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "0.2rem",
//                   }}
//                 >
//                   <FaCheck size={10} /> Completed
//                 </span>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Right Column - Content */}
//         <div>
//           <motion.div
//             initial={{ opacity: 0, x: 20 }}
//             animate={{ opacity: 1, x: 0 }}
//             style={{
//               background: getCardBackground(),
//               borderRadius: "20px",
//               padding: "1.5rem",
//               border: `1px solid ${getBorderColor()}`,
//             }}
//           >
//             <h1
//               style={{
//                 color: getTextColor(),
//                 fontSize: isMobile ? "1.3rem" : "1.5rem",
//                 marginBottom: "0.5rem",
//               }}
//             >
//               {topic.title}
//             </h1>

//             <p
//               style={{
//                 color: getTextSecondary(),
//                 lineHeight: "1.6",
//                 marginBottom: "1.5rem",
//                 fontSize: "0.9rem",
//               }}
//             >
//               {topic.description}
//             </p>

//             {/* Learning Outcomes */}
//             {topic.learningOutcomes?.length > 0 && (
//               <div style={{ marginBottom: "1.5rem" }}>
//                 <h3
//                   style={{
//                     color: getTextColor(),
//                     marginBottom: "0.5rem",
//                     fontSize: "1rem",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "0.3rem",
//                   }}
//                 >
//                   <FaStar color="#f59e0b" /> What You'll Learn
//                 </h3>
//                 <ul
//                   style={{
//                     color: getTextSecondary(),
//                     paddingLeft: "1.2rem",
//                     margin: 0,
//                   }}
//                 >
//                   {topic.learningOutcomes.map((outcome, idx) => (
//                     <li
//                       key={idx}
//                       style={{ marginBottom: "0.3rem", fontSize: "0.85rem" }}
//                     >
//                       {outcome}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             {/* Prerequisites */}
//             {topic.prerequisites?.length > 0 && (
//               <div style={{ marginBottom: "1.5rem" }}>
//                 <h3
//                   style={{
//                     color: getTextColor(),
//                     marginBottom: "0.5rem",
//                     fontSize: "1rem",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "0.3rem",
//                   }}
//                 >
//                   <FaList /> Prerequisites
//                 </h3>
//                 <ul
//                   style={{
//                     color: getTextSecondary(),
//                     paddingLeft: "1.2rem",
//                     margin: 0,
//                   }}
//                 >
//                   {topic.prerequisites.map((pre, idx) => (
//                     <li
//                       key={idx}
//                       style={{ marginBottom: "0.3rem", fontSize: "0.85rem" }}
//                     >
//                       {pre}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             {/* Additional Resources */}
//             {topic.resources?.length > 0 && (
//               <div style={{ marginBottom: "1.5rem" }}>
//                 <h3
//                   style={{
//                     color: getTextColor(),
//                     marginBottom: "0.5rem",
//                     fontSize: "1rem",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "0.3rem",
//                   }}
//                 >
//                   <FaBookOpen /> Additional Resources
//                 </h3>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "0.5rem",
//                   }}
//                 >
//                   {topic.resources.map((resource, idx) => (
//                     <a
//                       key={idx}
//                       href={resource.url}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "0.5rem",
//                         padding: "0.5rem",
//                         background: isDarkMode
//                           ? "rgba(139,92,246,0.1)"
//                           : "#f8f9fa",
//                         borderRadius: "8px",
//                         color: "#8b5cf6",
//                         textDecoration: "none",
//                         fontSize: "0.85rem",
//                       }}
//                     >
//                       <FaExternalLinkAlt size={12} />
//                       {resource.title}
//                     </a>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {/* Notes Section - Toggle for mobile */}
//             <div style={{ marginBottom: "1.5rem" }}>
//               <button
//                 onClick={() => setShowNotes(!showNotes)}
//                 style={{
//                   display: isMobile ? "flex" : "none",
//                   alignItems: "center",
//                   gap: "0.5rem",
//                   background: "none",
//                   border: "none",
//                   color: "#8b5cf6",
//                   cursor: "pointer",
//                   marginBottom: "0.5rem",
//                   fontSize: "0.85rem",
//                 }}
//               >
//                 <FaSave /> {showNotes ? "Hide Notes" : "Show Notes"}
//               </button>

//               {(showNotes || !isMobile) && (
//                 <>
//                   <h3
//                     style={{
//                       color: getTextColor(),
//                       marginBottom: "0.5rem",
//                       fontSize: "1rem",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.3rem",
//                     }}
//                   >
//                     <FaSave /> Your Notes
//                   </h3>
//                   <textarea
//                     value={notes}
//                     onChange={(e) => setNotes(e.target.value)}
//                     onBlur={updateProgress}
//                     placeholder="Take notes while watching the video..."
//                     rows="4"
//                     style={{
//                       width: "100%",
//                       padding: "0.8rem",
//                       background: getInputBackground(),
//                       border: `2px solid ${getBorderColor()}`,
//                       borderRadius: "12px",
//                       color: getTextColor(),
//                       fontSize: "0.85rem",
//                       resize: "vertical",
//                       outline: "none",
//                     }}
//                   />
//                 </>
//               )}
//             </div>

//             {/* Complete Button */}
//             {!isCompleted && (
//               <button
//                 onClick={handleMarkComplete}
//                 disabled={markingComplete}
//                 style={{
//                   width: "100%",
//                   padding: "1rem",
//                   background: markingComplete ? "#94a3b8" : "#10b981",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "12px",
//                   cursor: markingComplete ? "not-allowed" : "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: "0.5rem",
//                   fontSize: "1rem",
//                   fontWeight: "600",
//                   marginBottom: "1rem",
//                 }}
//               >
//                 {markingComplete ? (
//                   <FaSpinner style={{ animation: "spin 1s linear infinite" }} />
//                 ) : (
//                   <FaCheckCircle />
//                 )}
//                 {markingComplete ? "Marking..." : "Mark as Completed"}
//               </button>
//             )}

//             {isCompleted && (
//               <div
//                 style={{
//                   width: "100%",
//                   padding: "1rem",
//                   background: "#10b98120",
//                   color: "#10b981",
//                   borderRadius: "12px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: "0.5rem",
//                   fontSize: "1rem",
//                   fontWeight: "600",
//                   marginBottom: "1rem",
//                 }}
//               >
//                 <FaCheckCircle /> Topic Completed!
//               </div>
//             )}

//             {/* Navigation Buttons */}
//             <div style={{ display: "flex", gap: "1rem", marginTop: "0.5rem" }}>
//               {previousTopic && (
//                 <button
//                   onClick={() =>
//                     navigate(`/learning/topic/${previousTopic._id}`)
//                   }
//                   style={{
//                     flex: 1,
//                     padding: "0.75rem",
//                     background: isDarkMode ? "rgba(139,92,246,0.1)" : "#f1f5f9",
//                     color: getTextColor(),
//                     border: `1px solid ${getBorderColor()}`,
//                     borderRadius: "10px",
//                     cursor: "pointer",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: "0.5rem",
//                     fontSize: "0.85rem",
//                   }}
//                 >
//                   <FaArrowLeft /> Previous
//                 </button>
//               )}
//               {nextTopic && (
//                 <button
//                   onClick={() => navigate(`/learning/topic/${nextTopic._id}`)}
//                   style={{
//                     flex: 1,
//                     padding: "0.75rem",
//                     background: nextTopic.isUnlocked
//                       ? "linear-gradient(135deg, #8b5cf6, #3b82f6)"
//                       : "#94a3b8",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "10px",
//                     cursor: nextTopic.isUnlocked ? "pointer" : "not-allowed",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: "0.5rem",
//                     fontSize: "0.85rem",
//                   }}
//                 >
//                   Next <FaArrowRight />
//                 </button>
//               )}
//             </div>
//           </motion.div>
//         </div>
//       </div>

//       <style>
//         {`
//           @keyframes spin {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// const getInputBackground = () => {
//   const isDarkMode =
//     document.documentElement.getAttribute("data-theme") === "dark";
//   return isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff";
// };

// export default TopicDetail;

import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaArrowLeft,
  FaArrowRight,
  FaCheckCircle,
  FaClock,
  FaBookOpen,
  FaSpinner,
  FaSave,
  FaExternalLinkAlt,
  FaList,
  FaCheck,
  FaGraduationCap,
  FaLock,
  FaInfoCircle,
} from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import axios from "../utils/axiosConfig";
import toast from "react-hot-toast";
import Loader from "../components/common/Loader";
import { useFooter } from "../context/FooterContext";

const TopicDetail = () => {
  const { topicId } = useParams();
  const navigate = useNavigate();
  const { setShowFooter } = useFooter();
  const [topic, setTopic] = useState(null);
  const [nextTopic, setNextTopic] = useState(null);
  const [previousTopic, setPreviousTopic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [markingComplete, setMarkingComplete] = useState(false);
  const [notes, setNotes] = useState("");
  const [timeSpent, setTimeSpent] = useState(0);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const timerRef = useRef(null);
  const [videoStarted, setVideoStarted] = useState(false);
  const [errorStatus, setErrorStatus] = useState(null);
  const fetchCalledRef = useRef(false);
  const toastShownRef = useRef(false);
  const abortControllerRef = useRef(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    setShowFooter(false);

    // Reset mounted flag
    isMountedRef.current = true;

    // Only fetch if user is authenticated and topicId exists
    const token = localStorage.getItem("token");
    if (token && topicId) {
      // Cancel any pending request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      // Create new abort controller
      abortControllerRef.current = new AbortController();
      fetchTopic();
    }

    checkDarkMode();
    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      isMountedRef.current = false;
      setShowFooter(true);
      if (timerRef.current) clearInterval(timerRef.current);
      window.removeEventListener("resize", checkMobile);
      // Cancel ongoing request on unmount
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      // Reset flags after delay to prevent immediate refetch
      setTimeout(() => {
        fetchCalledRef.current = false;
        toastShownRef.current = false;
      }, 500);
    };
  }, [topicId]);

  const checkMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const checkDarkMode = () => {
    const dark = document.documentElement.getAttribute("data-theme") === "dark";
    setIsDarkMode(dark);
    const observer = new MutationObserver(() => {
      const dark =
        document.documentElement.getAttribute("data-theme") === "dark";
      setIsDarkMode(dark);
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  };

  const fetchTopic = async () => {
    // Don't proceed if component unmounted
    if (!isMountedRef.current) return;

    setLoading(true);
    setErrorStatus(null);

    try {
      const response = await axios.get(`/api/roadmap/topics/${topicId}`, {
        signal: abortControllerRef.current?.signal,
      });

      if (!isMountedRef.current) return;

      setTopic(response.data.topic);
      setNextTopic(response.data.nextTopic);
      setPreviousTopic(response.data.previousTopic);
      setNotes(response.data.topic.progress?.notes || "");
      setTimeSpent(response.data.topic.progress?.timeSpent || 0);
      toastShownRef.current = false;
    } catch (error) {
      // Ignore abort errors
      if (error.name === "AbortError" || error.code === "ERR_CANCELED") {
        return;
      }

      if (!isMountedRef.current) return;

      const status = error.response?.status;
      const message = error.response?.data?.message || "Failed to fetch topic";

      setErrorStatus(status);

      // Handle 403 errors gracefully - show toast only once
      if (status === 403 && !toastShownRef.current) {
        toastShownRef.current = true;
        toast.error("Complete previous topics first");
        // Navigate back
        navigate(-1);
        return;
      }

      // Handle 404 errors
      if (status === 404 && !toastShownRef.current) {
        toastShownRef.current = true;
        toast.error("Topic not found");
        navigate("/learning/my-learning");
        return;
      }

      // Handle all other errors
      if (!toastShownRef.current) {
        toastShownRef.current = true;
        toast.error("Failed to fetch topic. Please try again.");
        console.error("Fetch topic error:", error);
        navigate("/learning/my-learning");
      }
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  };

  const startTimer = () => {
    if (
      !timerRef.current &&
      !videoStarted &&
      topic?.progress?.status !== "completed"
    ) {
      setVideoStarted(true);
      timerRef.current = setInterval(() => {
        setTimeSpent((prev) => prev + 1);
      }, 1000);
    }
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const updateProgress = async () => {
    if (!topicId || !topic) return;
    try {
      await axios.put(`/api/roadmap/topics/${topicId}/progress`, {
        timeSpent: (topic?.progress?.timeSpent || 0) + timeSpent,
        notes,
      });
    } catch (error) {
      console.error("Failed to update progress:", error);
    }
  };

  const handleMarkComplete = async () => {
    if (!topicId) return;

    setMarkingComplete(true);
    stopTimer();
    try {
      await axios.post(`/api/roadmap/topics/${topicId}/complete`, {
        timeSpent: (topic?.progress?.timeSpent || 0) + timeSpent,
        notes,
      });
      toast.success("Topic completed successfully");

      if (nextTopic?.isUnlocked) {
        navigate(`/learning/topic/${nextTopic._id}`);
      } else if (topic?.domainId?._id) {
        navigate(`/learning/course/${topic.domainId._id}`);
      } else {
        navigate("/learning/my-learning");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to mark topic as completed";
      toast.error(errorMsg);
      setMarkingComplete(false);
    }
  };

  const extractYouTubeId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2]?.length === 11 ? match[2] : null;
  };

  const getYouTubeEmbedUrl = (url) => {
    const videoId = extractYouTubeId(url);
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return url;
  };

  const getTextColor = () => (isDarkMode ? "#f1f5f9" : "#1e293b");
  const getTextSecondary = () => (isDarkMode ? "#94a3b8" : "#64748b");
  const getBorderColor = () =>
    isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
  const getCardBackground = () =>
    isDarkMode ? "rgba(30, 30, 45, 0.8)" : "rgba(255, 255, 255, 0.9)";
  const getInputBackground = () => (isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff");

  // Show locked message if 403 error occurred
  if (errorStatus === 403) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: isMobile ? "1rem" : "2rem",
          background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
        }}
      >
        <div
          style={{
            maxWidth: "500px",
            width: "100%",
            background: getCardBackground(),
            borderRadius: "24px",
            padding: "3rem 2rem",
            border: `1px solid ${getBorderColor()}`,
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              background: "#ef444420",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 1.5rem",
            }}
          >
            <FaLock size={40} color="#ef4444" />
          </div>
          <h2
            style={{
              color: getTextColor(),
              marginBottom: "1rem",
              fontSize: "1.5rem",
              fontWeight: "bold",
            }}
          >
            Topic Locked
          </h2>
          <p
            style={{
              color: getTextSecondary(),
              marginBottom: "1.5rem",
              lineHeight: "1.6",
            }}
          >
            Complete previous topics first to unlock this lesson.
          </p>
          <button
            onClick={() => navigate("/learning/my-learning")}
            style={{
              padding: "0.8rem 2rem",
              background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
              color: "white",
              border: "none",
              borderRadius: "12px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "0.9rem",
              transition: "transform 0.2s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.02)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            Go to My Learning
          </button>
        </div>
      </div>
    );
  }

  if (loading) return <Loader />;

  if (!topic && !errorStatus) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "2rem",
          }}
        >
          <p style={{ color: getTextSecondary() }}>Topic not found</p>
          <button
            onClick={() => navigate("/learning/my-learning")}
            style={{
              marginTop: "1rem",
              padding: "0.6rem 1.5rem",
              background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Back to Learning
          </button>
        </div>
      </div>
    );
  }

  const isCompleted = topic?.progress?.status === "completed";
  const isInProgress = topic?.progress?.status === "in_progress";
  const youtubeEmbedUrl = getYouTubeEmbedUrl(topic?.primaryVideo);

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: isMobile ? "1rem" : "2rem",
        background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
        minHeight: "100vh",
      }}
    >
      {/* Navigation Bar */}
      <div
        style={{
          marginBottom: "1.5rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            background: "none",
            border: "none",
            color: "#8b5cf6",
            cursor: "pointer",
            fontSize: "0.9rem",
            padding: "0.5rem 1rem",
            borderRadius: "8px",
            transition: "background 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = isDarkMode
              ? "rgba(139,92,246,0.1)"
              : "#f1f5f9")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          <FaArrowLeft /> Back to Course
        </button>

        <div style={{ display: "flex", gap: "0.5rem" }}>
          <span
            style={{
              fontSize: "0.8rem",
              color: getTextSecondary(),
              background: getCardBackground(),
              padding: "0.3rem 0.8rem",
              borderRadius: "20px",
              border: `1px solid ${getBorderColor()}`,
            }}
          >
            {topic?.domainId?.name}
          </span>
        </div>
      </div>

      {/* Main Content */}
      {topic && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
          }}
        >
          {/* Video Player Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            style={{
              background: "#000000",
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <div style={{ position: "relative", paddingBottom: "56.25%" }}>
              <iframe
                src={youtubeEmbedUrl}
                title={topic.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                onLoad={startTimer}
              />
            </div>
          </motion.div>

          {/* Video Info Row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  flexWrap: "wrap",
                  marginBottom: "0.5rem",
                }}
              >
                <span
                  style={{
                    fontSize: "0.7rem",
                    color: getTextSecondary(),
                    display: "flex",
                    alignItems: "center",
                    gap: "0.3rem",
                    background: isDarkMode
                      ? "rgba(255,255,255,0.05)"
                      : "#f8f9fa",
                    padding: "0.2rem 0.6rem",
                    borderRadius: "20px",
                  }}
                >
                  <FaClock size={10} /> {topic.estimatedTime} min
                </span>
                {topic.difficulty && (
                  <span
                    style={{
                      fontSize: "0.65rem",
                      padding: "0.2rem 0.6rem",
                      borderRadius: "20px",
                      background:
                        topic.difficulty === "beginner"
                          ? "#10b98120"
                          : topic.difficulty === "intermediate"
                            ? "#f59e0b20"
                            : "#ef444420",
                      color:
                        topic.difficulty === "beginner"
                          ? "#10b981"
                          : topic.difficulty === "intermediate"
                            ? "#f59e0b"
                            : "#ef4444",
                    }}
                  >
                    {topic.difficulty.charAt(0).toUpperCase() +
                      topic.difficulty.slice(1)}
                  </span>
                )}
                {isInProgress && !isCompleted && (
                  <span
                    style={{
                      fontSize: "0.65rem",
                      color: "#8b5cf6",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.2rem",
                      background: "#8b5cf620",
                      padding: "0.2rem 0.6rem",
                      borderRadius: "20px",
                    }}
                  >
                    <FaInfoCircle size={10} /> In Progress
                  </span>
                )}
                {isCompleted && (
                  <span
                    style={{
                      fontSize: "0.65rem",
                      color: "#10b981",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.2rem",
                      background: "#10b98120",
                      padding: "0.2rem 0.6rem",
                      borderRadius: "20px",
                    }}
                  >
                    <FaCheck size={10} /> Completed
                  </span>
                )}
              </div>
              <h1
                style={{
                  color: getTextColor(),
                  fontSize: isMobile ? "1.3rem" : "1.5rem",
                  marginBottom: "0.3rem",
                  fontWeight: "bold",
                }}
              >
                {topic.title}
              </h1>
            </div>

            {!isCompleted && (
              <button
                onClick={handleMarkComplete}
                disabled={markingComplete}
                style={{
                  padding: "0.8rem 1.5rem",
                  background: markingComplete ? "#94a3b8" : "#10b981",
                  color: "white",
                  border: "none",
                  borderRadius: "12px",
                  cursor: markingComplete ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  transition: "background 0.2s",
                  minWidth: "180px",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => {
                  if (!markingComplete)
                    e.currentTarget.style.background = "#059669";
                }}
                onMouseLeave={(e) => {
                  if (!markingComplete)
                    e.currentTarget.style.background = "#10b981";
                }}
              >
                {markingComplete ? (
                  <FaSpinner style={{ animation: "spin 1s linear infinite" }} />
                ) : (
                  <FaCheckCircle />
                )}
                {markingComplete ? "Marking..." : "Mark as Completed"}
              </button>
            )}

            {isCompleted && (
              <div
                style={{
                  padding: "0.8rem 1.5rem",
                  background: "#10b98120",
                  color: "#10b981",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  border: `1px solid #10b98140`,
                  minWidth: "180px",
                  justifyContent: "center",
                }}
              >
                <FaCheckCircle /> Completed
              </div>
            )}
          </div>

          {/* Description */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            style={{
              background: getCardBackground(),
              borderRadius: "16px",
              padding: "1rem",
              border: `1px solid ${getBorderColor()}`,
            }}
          >
            <p
              style={{
                color: getTextSecondary(),
                lineHeight: "1.6",
                margin: 0,
                fontSize: "0.95rem",
              }}
            >
              {topic.description}
            </p>
          </motion.div>

          {/* Two Column Layout */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: "1.5rem",
            }}
          >
            {/* Left Column */}
            <div
              style={{
                background: getCardBackground(),
                borderRadius: "16px",
                padding: "1.5rem",
                border: `1px solid ${getBorderColor()}`,
              }}
            >
              {topic.learningOutcomes?.length > 0 && (
                <div style={{ marginBottom: "1.5rem" }}>
                  <h3
                    style={{
                      color: getTextColor(),
                      marginBottom: "0.75rem",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      fontWeight: "600",
                    }}
                  >
                    <FaGraduationCap color="#8b5cf6" size={16} />
                    What You'll Learn
                  </h3>
                  <ul
                    style={{
                      color: getTextSecondary(),
                      paddingLeft: "1.2rem",
                      margin: 0,
                    }}
                  >
                    {topic.learningOutcomes.map((outcome, idx) => (
                      <li
                        key={idx}
                        style={{
                          marginBottom: "0.5rem",
                          fontSize: "0.9rem",
                          lineHeight: "1.5",
                        }}
                      >
                        {outcome}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {topic.prerequisites?.length > 0 && (
                <div>
                  <h3
                    style={{
                      color: getTextColor(),
                      marginBottom: "0.75rem",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      fontWeight: "600",
                    }}
                  >
                    <FaList color="#f59e0b" size={16} />
                    Prerequisites
                  </h3>
                  <ul
                    style={{
                      color: getTextSecondary(),
                      paddingLeft: "1.2rem",
                      margin: 0,
                    }}
                  >
                    {topic.prerequisites.map((pre, idx) => (
                      <li
                        key={idx}
                        style={{
                          marginBottom: "0.5rem",
                          fontSize: "0.9rem",
                          lineHeight: "1.5",
                        }}
                      >
                        {pre}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Right Column - Notes */}
            <div
              style={{
                background: getCardBackground(),
                borderRadius: "16px",
                padding: "1.5rem",
                border: `1px solid ${getBorderColor()}`,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h3
                style={{
                  color: getTextColor(),
                  marginBottom: "0.75rem",
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  fontWeight: "600",
                }}
              >
                <FaSave color="#8b5cf6" size={16} />
                Your Notes
              </h3>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                onBlur={updateProgress}
                placeholder="Take notes while watching the video..."
                rows="6"
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  background: getInputBackground(),
                  border: `2px solid ${getBorderColor()}`,
                  borderRadius: "12px",
                  color: getTextColor(),
                  fontSize: "0.9rem",
                  resize: "vertical",
                  outline: "none",
                  lineHeight: "1.6",
                  fontFamily: "inherit",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
                onBlur={(e) => {
                  e.target.style.borderColor = getBorderColor();
                  updateProgress();
                }}
              />

              {videoStarted && !isCompleted && (
                <div
                  style={{
                    marginTop: "1rem",
                    padding: "0.5rem",
                    background: isDarkMode
                      ? "rgba(139,92,246,0.08)"
                      : "#f8fafc",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontSize: "0.8rem",
                    color: getTextSecondary(),
                    border: `1px solid ${getBorderColor()}`,
                  }}
                >
                  <span>Time spent learning</span>
                  <span style={{ fontWeight: "bold", color: "#8b5cf6" }}>
                    {Math.floor(timeSpent / 60)}m {timeSpent % 60}s
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Additional Resources */}
          {topic.resources?.length > 0 && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              style={{
                background: getCardBackground(),
                borderRadius: "16px",
                padding: "1.5rem",
                border: `1px solid ${getBorderColor()}`,
              }}
            >
              <h3
                style={{
                  color: getTextColor(),
                  marginBottom: "0.75rem",
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  fontWeight: "600",
                }}
              >
                <FaBookOpen color="#10b981" size={16} />
                Additional Resources
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
              >
                {topic.resources.map((resource, idx) => (
                  <a
                    key={idx}
                    href={resource.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      padding: "0.6rem",
                      background: isDarkMode
                        ? "rgba(139,92,246,0.08)"
                        : "#f8fafc",
                      borderRadius: "10px",
                      color: "#8b5cf6",
                      textDecoration: "none",
                      fontSize: "0.85rem",
                      border: `1px solid ${getBorderColor()}`,
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = isDarkMode
                        ? "rgba(139,92,246,0.15)"
                        : "#f1f5f9";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = isDarkMode
                        ? "rgba(139,92,246,0.08)"
                        : "#f8fafc";
                    }}
                  >
                    <FaExternalLinkAlt size={12} />
                    {resource.title}
                  </a>
                ))}
              </div>
            </motion.div>
          )}

          {/* Navigation Buttons */}
          {(previousTopic || nextTopic) && (
            <div
              style={{
                display: "flex",
                gap: "1rem",
                marginTop: "0.5rem",
              }}
            >
              {previousTopic && (
                <button
                  onClick={() =>
                    navigate(`/learning/topic/${previousTopic._id}`)
                  }
                  style={{
                    flex: 1,
                    padding: "0.8rem",
                    background: isDarkMode ? "rgba(139,92,246,0.1)" : "#f1f5f9",
                    color: getTextColor(),
                    border: `1px solid ${getBorderColor()}`,
                    borderRadius: "12px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = isDarkMode
                      ? "rgba(139,92,246,0.2)"
                      : "#e5e7eb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = isDarkMode
                      ? "rgba(139,92,246,0.1)"
                      : "#f1f5f9";
                  }}
                >
                  <FaArrowLeft /> Previous Topic
                </button>
              )}
              {nextTopic && (
                <button
                  onClick={() => navigate(`/learning/topic/${nextTopic._id}`)}
                  disabled={!nextTopic.isUnlocked}
                  style={{
                    flex: 1,
                    padding: "0.8rem",
                    background: nextTopic.isUnlocked
                      ? "linear-gradient(135deg, #8b5cf6, #3b82f6)"
                      : "#94a3b8",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                    cursor: nextTopic.isUnlocked ? "pointer" : "not-allowed",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    opacity: nextTopic.isUnlocked ? 1 : 0.6,
                  }}
                >
                  Next Topic <FaArrowRight />
                </button>
              )}
            </div>
          )}
        </div>
      )}

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default TopicDetail;
